export default __webpack_public_path__ + "static/media/lotr.24efbf5c.jpg";